<template>
  <app-board :header="false" class="mb-3 lcr-panel-decoration" v-if="amReady">

    <div v-if="lcrReportModule && lcrTopDestinationsModule">
      <el-tabs :key="key" :tab-position="tabPosition" @tab-click="handleClick"
               v-for="(divisionsList, key) in divisionsMaster"
               v-model="selectedTab">

        <el-tab-pane :key="divKey" :lazy="true" :name="getTabName(divisionsList[divKey].label)" class="p-0"
         v-for="(division, divKey) in divisionsList">

          <!--<span :class="{'pr-5':(divKey % 2 != 0 && divKey != 0)? true : false}" class="ml-2" slot="label">
            {{ getTabLabel(divisionsList) }}
          </span>-->

          <span :class="{'c-pl-5':(divKey % 2 == 0 && divKey != 0 && divKey != 2)? true : false, 'c-pl-6': ((divKey % 4 == 0 || divKey ==2) && divKey != 0)? true : false}" class="ml-2" slot="label">
            {{ getTabLabel(divisionsList) }}
          </span>

          <div v-if="isItReportTurn()">
            <div v-if="routeTabName === ('lcrReport'+divisionsList[divKey].label)">
              <lcrReport :default-division="divisionsList[divKey].value"></lcrReport>
            </div>
          </div>
          <div v-else>
            <div v-if="routeTabName === ('lcrTopDestinations'+divisionsList[divKey].label)">
              <lcrTopDestinations
                  :default-division="divisionsList[divKey].value"></lcrTopDestinations>
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else-if="lcrTopDestinationsModule">
      <el-tabs :key="key" :tab-position="tabPosition" @tab-click="handleClick"
               v-for="(divisionsList, key) in divisionsMaster"
               v-model="selectedTab">
        <el-tab-pane :key="divKey" :lazy="true" :name="'lcrTopDestinations' + division.label"
                     class="p-0" v-for="(division, divKey) in listRealList">
          <span :class="{'pr-2':isEven(divKey)}" class="ml-2" slot="label"> {{ 'Top ' + division.label }}</span>
          <div v-if="routeTabName === ('lcrTopDestinations'+division.label)">
            <lcrTopDestinations :default-division="division.value"></lcrTopDestinations>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

  </app-board>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import panelMixin from "@/app/portals/cpanel/mixins/util";
let tabIndexStepName = 0
let tabIndexStep = 0
let tabIndexBuilderCounter = 0

export default {
  mixins: [panelMixin],
  components: {
    lcrReport: () => import('@/modules/voip-lcr-report/lcr/report/page/View'),
    lcrTopDestinations: () => import('@/modules/voip-lcr-top-destinations/lcr/top-destination/page/View')
  },
  methods: {
    isEven(n) {
      return n % 2 == 0;
    },
    getTabLabel(divisionsList) {
      let label = divisionsList[tabIndexBuilderCounter].label
      if (!this.isEven(tabIndexStep)) {
        return 'Top ' + label
      }
      return 'Report ' + label
    },
    isItReportTurn(divisionLabel) {
      tabIndexStep += 1
      if (tabIndexBuilderCounter < this.divisionsMaster[0].length - 1) {
        tabIndexBuilderCounter += 1
      } else {
        tabIndexBuilderCounter = 0
      }

      if (this.isEven(tabIndexStep)) {
        tabIndexStep = 0
        return false
      }
      return true
    },
    getTabName(divisionLabel) {
      if (this.isEven(++tabIndexStepName)) {
        return 'lcrTopDestinations' + divisionLabel
      }
      return 'lcrReport' + divisionLabel

    },
    handleClick(tab, event) {
      let tabName = tab.$props.name
      this.$router.push({name: 'module->voip-lcr-menu->lcr-panel->tab', params: {tabName: tabName}})
    }
  },
  computed: {
    ...mapState('user-state', {
      userModules: 'modules'
    }),
  },
  mounted() {
    tabIndexStepName = 0
    tabIndexStep = 0
    tabIndexBuilderCounter = 0
  },
  beforeMount() {
    tabIndexStepName = 0
    tabIndexStep = 0
    tabIndexBuilderCounter = 0
    if (!this.routeTabName) {
      let tabName = ''
      if (this.lcrReportModule) {
        tabName = 'lcrReportCLI'
      } else if (this.lcrTopDestinationsModule) {
        tabName = 'lcrTopDestinationsCLI'
      }
      this.$router.push({name: 'module->voip-lcr-menu->lcr-panel->tab', params: {tabName: tabName}})
    } else {
      this.panelMixin_getUserVoipDivision('__divisionsList', (r) => {
        if (!this.listRealList.length) {
          let len = r.length

          this.listRealList = r
          this.listRealLength = len
          let dublicate = []
          for (let i = 0; i < len; i++) {
            dublicate.push(r[i])
            dublicate.push(r[i])
          }
          /*for (let i = 0; i < len; i++) {
            dublicate.push(r[i])
          }*/

          this.divisionsMaster.push(dublicate)
          tabIndexStepName = 0
          tabIndexStep = 0
          tabIndexBuilderCounter = 0
          this.amReady = true
        }
      })

      /*this.getDivisionsDropDownList().then(r => {
        if (!this.listRealList.length) {
          let len = r.length

          this.listRealList = r
          this.listRealLength = len
          let dublicate = []
          for (let i = 0; i < len; i++) {
            dublicate.push(r[i])
            dublicate.push(r[i])
          }
          /!*for (let i = 0; i < len; i++) {
            dublicate.push(r[i])
          }*!/

          this.divisionsMaster.push(dublicate)
          tabIndexStepName = 0
          tabIndexStep = 0
          tabIndexBuilderCounter = 0
          this.amReady = true
        }
      })*/
    }

  },
  data() {
    return {
      listRealList: [],
      listRealLength: 0,
      tabIndexStep: 0,
      divisionsMaster: [],
      amReady: false,
      routeTabName: this.$route.params.tabName,
      tabPosition: 'top',
      selectedTab: this.$route.params.tabName,
      // lcrReportModule: $store.getters['user-state/userHasModule']('voip-lcr-menu'),
      lcrReportModule: this.$store.hasModule('voip-lcr-report-api'),
      lcrTopDestinationsModule: this.$store.hasModule('voip-lcr-top-destinations-api'),
    };
  }
};
</script>
